module.exports = __webpack_public_path__ + "static/media/logo-1.5c396116.png";